import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Image, Card, Form, Badge, Accordion, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPhoneAlt, FaEye, FaRegHeart, FaShareAlt, FaRegPaperPlane, FaHeart , FaVideo, FaCheckCircle} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import BaseUrl from '../../ApiServices/BaseUrl';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import ReportCandidate from './ReportCandidate';
import './Candidates_admin.css';
import { getVisibleOfferBadgeText, getVisibleSourceLabel, hasHighlightedSourceLabel, hasVisibleOfferBadge } from '../../../utils/candidateBadges';

function Candidates_admin() {
    const [candidates, setCandidates] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [showMoreJobPosition, setShowMoreJobPosition] = useState(false);
    const [showMoreJobType, setShowMoreJobType] = useState(false);
    const [showMoreLanguage, setShowMoreLanguage] = useState(false);
    const [showMoreMainSkills, setShowMoreMainSkills] = useState(false);
    const [messages, setMessages] = useState([]);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const autoSearchTimeoutRef = useRef(null);
    const isAutoSearchingRef = useRef(false);
    // Mobile responsive states
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    // Message modal state
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageContent, setMessageContent] = useState("I'm interested");
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedCandidateForReport, setSelectedCandidateForReport] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareContent, setShareContent] = useState('');
    const [shareUrl, setShareUrl] = useState('');
    const [showLocation, setShowLocation] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostedBy, setShowPostedBy] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);
    const [shortlistedCandidates, setShortlistedCandidates] = useState({});

    // Filter states
    const [jobPosition, setJobPosition] = useState({
        maid: false,
        driver: false,
        cook: false,
        nanny: false,
        nurse: false,
        houseboy: false,
        tailor: false,
        teacher: false,
        trainer: false,
        gardener: false,
        butler: false,
        housekeeper: false,
        laundryWorker: false,
        personalAssistant: false,
        caregiver: false,
        elderCareCompanion: false,
        petSitter: false,
        houseManager: false,
        cleaner: false,
        maintenanceWorker: false,
        babySitter: false,
        tutor: false,
        chauffeur: false,
        housemaid: false,
        kitchenStaff: false,
        diningRoomAttendant: false,
        personalChef: false,
        eventCoordinator: false,
        householdAdministrator: false,
        domesticAssistant: false
    });
    const [jobCountry, setJobCountry] = useState({
        qatar: false,
        uae: false,
        saudiArabia: false,
        kuwait: false,
        bahrain: false,
        oman: false,
        usa: false,
        canada: false,
        uk: false,
        australia: false,
        germany: false,
        france: false,
        italy: false,
        spain: false,
        netherlands: false,
        belgium: false,
        switzerland: false,
        sweden: false,
        norway: false,
        denmark: false,
        finland: false,
        japan: false,
        southKorea: false,
        singapore: false,
        malaysia: false,
        china: false,
        hongKong: false,
        newZealand: false,
        southAfrica: false,
        brazil: false,
        mexico: false,
        argentina: false,
        chile: false,
        colombia: false,
        peru: false,
        egypt: false,
        morocco: false,
        algeria: false,
        tunisia: false,
        jordan: false,
        lebanon: false,
        iraq: false,
        iran: false,
        turkey: false,
        cyprus: false,
        malta: false,
        greece: false,
        portugal: false,
        austria: false,
        hungary: false,
        poland: false,
        czechRepublic: false,
        slovakia: false,
        slovenia: false,
        croatia: false,
        romania: false,
        bulgaria: false,
        serbia: false,
        montenegro: false,
        albania: false,
        northMacedonia: false,
        bosniaHerzegovina: false,
        kosovo: false,
        estonia: false,
        latvia: false,
        lithuania: false,
        belarus: false,
        ukraine: false,
        moldova: false,
        georgia: false,
        armenia: false,
        azerbaijan: false,
        kazakhstan: false,
        uzbekistan: false,
        turkmenistan: false,
        kyrgyzstan: false,
        tajikistan: false,
        afghanistan: false,
        pakistan: false,
        india: false,
        bangladesh: false,
        sriLanka: false,
        nepal: false,
        bhutan: false,
        myanmar: false,
        thailand: false,
        laos: false,
        cambodia: false,
        vietnam: false,
        indonesia: false,
        philippines: false,
        brunei: false,
        eastTimor: false,
        papuaNewGuinea: false,
        fiji: false,
        solomonIslands: false,
        vanuatu: false,
        samoa: false,
        tonga: false,
        marshallIslands: false,
        micronesia: false,
        palau: false,
        nauru: false,
        tuvalu: false,
        kiribati: false
    });
    const [showMoreJobCountry, setShowMoreJobCountry] = useState(false);
    const [candidateLocation, setCandidateLocation] = useState({
        india: false,
        bangladesh: false,
        nepal: false,
        sriLanka: false,
        pakistan: false,
        philippines: false,
        indonesia: false,
        myanmar: false,
        vietnam: false,
        cambodia: false,
        thailand: false,
        ethiopia: false,
        kenya: false,
        uganda: false,
        tanzania: false,
        rwanda: false,
        ghana: false,
        nigeria: false,
        sierraLeone: false,
        burundi: false
    });
    const [jobType, setJobType] = useState({
        fullTime: false,
        partTime: false,
        liveIn: false,
        liveOut: false,
        temporary: false,
        permanent: false,
        internship: false,
        contractual: false,
        freelance: false,
        volunteer: false,
        fresher: false
    });
    const [contractStatus, setContractStatus] = useState({
        permanent: false,
        temporary: false,
        contract: false
    });
    const [postedBy, setPostedBy] = useState({
        agency: false,
        directEmployer: false
    });
    const [language, setLanguage] = useState({
        english: false,
        mandarin: false,
        arabic: false,
        hindi: false,
        tagalog: false,
        cantonese: false,
        malay: false,
        tamil: false
    });
    const [mainSkills, setMainSkills] = useState({
        childcare: false,
        elderlyCare: false,
        cooking: false,
        cleaning: false,
        laundry: false,
        ironing: false,
        petCare: false,
        gardening: false
    });
    const [startDate, setStartDate] = useState('');
    const [showMoreLocations, setShowMoreLocations] = useState(false);

    const handleJobPositionChange = (e) => {
        const { name, checked } = e.target;
        setJobPosition(prev => ({
            ...prev,
            [name]: checked
        }));
    };
    const handleJobCountryChange = (e) => {
        const { name, checked } = e.target;
        setJobCountry(prev => ({
            ...prev,
            [name]: checked
        }));
    };
    const resetAllFilters = () => {
        setJobPosition({
            maid: false,
            driver: false,
            cook: false,
            nanny: false,
            nurse: false,
            houseboy: false,
            tailor: false,
            teacher: false,
            trainer: false,
            gardener: false,
            butler: false,
            housekeeper: false,
            laundryWorker: false,
            personalAssistant: false,
            caregiver: false,
            elderCareCompanion: false,
            petSitter: false,
            houseManager: false,
            cleaner: false,
            maintenanceWorker: false,
            babySitter: false,
            tutor: false,
            chauffeur: false,
            housemaid: false,
            kitchenStaff: false,
            diningRoomAttendant: false,
            personalChef: false,
            eventCoordinator: false,
            householdAdministrator: false,
            domesticAssistant: false
        });
        // Inside resetAllFilters function, add this:
        setJobCountry({
            qatar: false,
            uae: false,
            saudiArabia: false,
            kuwait: false,
            bahrain: false,
            oman: false,
            usa: false,
            canada: false,
            uk: false,
            australia: false,
            germany: false,
            france: false,
            italy: false,
            spain: false,
            netherlands: false,
            belgium: false,
            switzerland: false,
            sweden: false,
            norway: false,
            denmark: false,
            finland: false,
            japan: false,
            southKorea: false,
            singapore: false,
            malaysia: false,
            china: false,
            hongKong: false,
            newZealand: false,
            southAfrica: false,
            brazil: false,
            mexico: false,
            argentina: false,
            chile: false,
            colombia: false,
            peru: false,
            egypt: false,
            morocco: false,
            algeria: false,
            tunisia: false,
            jordan: false,
            lebanon: false,
            iraq: false,
            iran: false,
            turkey: false,
            cyprus: false,
            malta: false,
            greece: false,
            portugal: false,
            austria: false,
            hungary: false,
            poland: false,
            czechRepublic: false,
            slovakia: false,
            slovenia: false,
            croatia: false,
            romania: false,
            bulgaria: false,
            serbia: false,
            montenegro: false,
            albania: false,
            northMacedonia: false,
            bosniaHerzegovina: false,
            kosovo: false,
            estonia: false,
            latvia: false,
            lithuania: false,
            belarus: false,
            ukraine: false,
            moldova: false,
            georgia: false,
            armenia: false,
            azerbaijan: false,
            kazakhstan: false,
            uzbekistan: false,
            turkmenistan: false,
            kyrgyzstan: false,
            tajikistan: false,
            afghanistan: false,
            pakistan: false,
            india: false,
            bangladesh: false,
            sriLanka: false,
            nepal: false,
            bhutan: false,
            myanmar: false,
            thailand: false,
            laos: false,
            cambodia: false,
            vietnam: false,
            indonesia: false,
            philippines: false,
            brunei: false,
            eastTimor: false,
            papuaNewGuinea: false,
            fiji: false,
            solomonIslands: false,
            vanuatu: false,
            samoa: false,
            tonga: false,
            marshallIslands: false,
            micronesia: false,
            palau: false,
            nauru: false,
            tuvalu: false,
            kiribati: false
        });
        setCandidateLocation({
            india: false,
            bangladesh: false,
            nepal: false,
            sriLanka: false,
            pakistan: false,
            philippines: false,
            indonesia: false,
            myanmar: false,
            vietnam: false,
            cambodia: false,
            thailand: false,
            ethiopia: false,
            kenya: false,
            uganda: false,
            tanzania: false,
            rwanda: false,
            ghana: false,
            nigeria: false,
            sierraLeone: false,
            burundi: false
        });
        setJobType({
            fullTime: false,
            partTime: false,
            liveIn: false,
            liveOut: false,
            temporary: false,
            permanent: false,
            internship: false,
            contractual: false,
            freelance: false,
            volunteer: false,
            fresher: false
        });
        setContractStatus({
            permanent: false,
            temporary: false,
            contract: false
        });
        setPostedBy({
            agency: false,
            directEmployer: false
        });
        setLanguage({
            english: false,
            mandarin: false,
            arabic: false,
            hindi: false,
            tagalog: false,
            cantonese: false,
            malay: false,
            tamil: false
        });
        setMainSkills({
            childcare: false,
            elderlyCare: false,
            cooking: false,
            cleaning: false,
            laundry: false,
            ironing: false,
            petCare: false,
            gardening: false
        });
        setStartDate('');
    };

    const handleCandidateLocationChange = (e) => {
        const { name, checked } = e.target;
        setCandidateLocation(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    // Update screen width on resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = screenWidth < 768; // Mobile breakpoint

    const handleJobTypeChange = (e) => {
        const { name, checked } = e.target;
        setJobType(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleContractStatusChange = (e) => {
        const { name, checked } = e.target;
        setContractStatus(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handlePostedByChange = (e) => {
        const { name, checked } = e.target;
        setPostedBy(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleLanguageChange = (e) => {
        const { name, checked } = e.target;
        setLanguage(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleMainSkillsChange = (e) => {
        const { name, checked } = e.target;
        setMainSkills(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const toggleMoreLocations = () => {
        setShowMoreLocations(!showMoreLocations);
    };

    const handleViewClick = (userId) => {
        navigate(`/candidatesviewadmin/${userId}`);
    };

    // Message modal handlers
    const handleMessageClick = (candidate) => {
        setSelectedCandidate(candidate);
        setShowMessageModal(true);
    };

    const handleCloseMessageModal = () => {
        setShowMessageModal(false);
        setMessageContent('');
        setSelectedCandidate(null);
    };

    const handleMessageContentChange = (e) => {
        setMessageContent(e.target.value);
    };

    const fetchMessages = async (adminId, jobSeekerId) => {
        try {
            const response = await fetch(`${BaseUrl}/message/${adminId}/${jobSeekerId}/get`);
            if (!response.ok) {
                throw new Error('Failed to fetch messages');
            }
            const data = await response.json();
            setMessages(data);
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    };

    useEffect(() => {
        const fetchShortlistedStatus = async () => {
            try {
                // For admin, we might want to track shortlisted candidates differently
                // Using localStorage for demo purposes
                const storedShortlisted = localStorage.getItem('admin_shortlisted_candidates');
                if (storedShortlisted) {
                    setShortlistedCandidates(JSON.parse(storedShortlisted));
                }
            } catch (error) {
                console.error('Error fetching shortlisted status:', error);
            }
        };

        fetchShortlistedStatus();
    }, []);

    const handleShortlistClick = (candidate) => {
        const candidateUserId = candidate.user_id;
        const isCurrentlyShortlisted = shortlistedCandidates[candidateUserId];
        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';

        // Immediately update state for instant UI feedback
        const updatedShortlisted = { ...shortlistedCandidates };

        if (isCurrentlyShortlisted) {
            // Remove from shortlist
            delete updatedShortlisted[candidateUserId];
            setShortlistedCandidates(updatedShortlisted);

            // Show quick success toast
            Swal.fire({
                icon: 'success',
                title: 'Removed!',
                text: `${candidateName} removed from shortlist`,
                timer: 1500,
                showConfirmButton: false,
                position: 'top-end',
                toast: true,
                width: 300,
                background: '#f0f9ff',
                iconColor: '#dc3545'
            });
        } else {
            // Add to shortlist
            updatedShortlisted[candidateUserId] = Date.now();
            setShortlistedCandidates(updatedShortlisted);

            // Show quick success toast
            Swal.fire({
                icon: 'success',
                title: 'Shortlisted!',
                text: `${candidateName} added to shortlist`,
                timer: 1500,
                showConfirmButton: false,
                position: 'top-end',
                toast: true,
                width: 300,
                background: '#f0f9ff',
                iconColor: '#28a745'
            });
        }

        // Save to localStorage (non-blocking)
        localStorage.setItem('admin_shortlisted_candidates', JSON.stringify(updatedShortlisted));
    };
    const handleShareClick = (candidate) => {
        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';
        const candidateAge = candidate.age ? `${candidate.age} years` : '';
        const nationality = candidate.nationality || '';

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : candidate.job_position || 'Domestic Worker';

        const experience = candidate.total_work_experience || 'Not specified';
        const currentLocation = candidate.current_country || 'Not specified';

        const shareText = `Check out ${candidateName}'s profile - ${jobPosition} | ${nationality} | ${candidateAge} | ${experience} experience | Currently in ${currentLocation}. Find more candidates on Gulf Worker.`;
        const shareUrl = `${window.location.origin}/candidatesviewadmin/${candidate.user_id}`;
        const fullShareContent = `${shareText} ${shareUrl}`;

        if (navigator.share) {
            navigator.share({
                title: `${candidateName} - ${jobPosition}`,
                text: shareText,
                url: shareUrl,
            })
                .catch((error) => console.log('Error sharing:', error));
        } else {
            setSelectedCandidate(candidate);
            setShareContent(fullShareContent);
            setShareUrl(shareUrl);
            setShowShareModal(true);
        }
    };

    // Share via WhatsApp
    const shareViaWhatsApp = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://wa.me/?text=${encodedText}`, '_blank');
    };

    // Share via Facebook
    const shareViaFacebook = (url) => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
    };

    // Share via Twitter
    const shareViaTwitter = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
    };

    // Share via LinkedIn
    const shareViaLinkedIn = (url) => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
    };

    // Copy to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'Copied!',
                text: 'Link copied to clipboard',
                timer: 1500,
                showConfirmButton: false
            });
        });
    };

    const handleSendMessage = async () => {
        if (!messageContent.trim() || !selectedCandidate) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: 'Please select a candidate and enter a message',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Sending message...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // For admin, we might store messages differently or just show success
            // This is a simplified version for admin
            await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Message sent successfully!',
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                handleCloseMessageModal();
                setMessageContent("I'm interested");
            });

        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    const applySearchTerm = async (rawSearchValue) => {
        setSearchTerm(rawSearchValue.trim());
    };

    useEffect(() => {
        if (autoSearchTimeoutRef.current) {
            clearTimeout(autoSearchTimeoutRef.current);
        }

        autoSearchTimeoutRef.current = setTimeout(async () => {
            if (isAutoSearchingRef.current) return;

            const normalizedSearchInput = searchInput.trim();
            if (normalizedSearchInput === searchTerm) return;

            isAutoSearchingRef.current = true;
            try {
                await applySearchTerm(searchInput);
            } finally {
                isAutoSearchingRef.current = false;
            }
        }, 350);

        return () => {
            if (autoSearchTimeoutRef.current) {
                clearTimeout(autoSearchTimeoutRef.current);
            }
        };
    }, [searchInput, searchTerm]);

    // Helper function to format dates correctly
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    // Helper function to safely parse array fields
    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const handleReportClick = (candidate) => {
        setSelectedCandidateForReport(candidate);
        setShowReportModal(true);
    };

    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/job-seeker/combine/all`);
                if (!response.ok) {
                    throw new Error('Failed to fetch candidates');
                }

                let data = await response.json();

                if (!data) {
                    console.log('No data received from API');
                    setCandidates([]);
                    setFilteredCandidates([]);
                    setLoading(false);
                    return;
                }

                if (!Array.isArray(data)) {
                    console.log('API response is not an array:', data);
                    if (data.data && Array.isArray(data.data)) {
                        data = data.data;
                    } else if (data.candidates && Array.isArray(data.candidates)) {
                        data = data.candidates;
                    } else if (data.users && Array.isArray(data.users)) {
                        data = data.users;
                    } else {
                        setCandidates([]);
                        setFilteredCandidates([]);
                        setLoading(false);
                        return;
                    }
                }

                // Parse array fields safely
                data = data.map(candidate => ({
                    ...candidate,
                    language: safeParseArray(candidate.language),
                    main_skills: safeParseArray(candidate.main_skills),
                    preferred_countries: safeParseArray(candidate.preferred_countries),
                    work_experience: safeParseArray(candidate.work_experience),
                    job_position: safeParseArray(candidate.job_position)
                }));

                // Append full URL to profile_photo if exists
                const updatedData = data.map(candidate => {
                    if (candidate && candidate.profile_photo) {
                        return {
                            ...candidate,
                            profile_photo: `${BaseUrl}${candidate.profile_photo}`
                        };
                    }
                    return candidate;
                });

                setCandidates(updatedData);
                setFilteredCandidates(updatedData);

                console.log('Total candidates:', data.length);

            } catch (err) {
                setError(err.message);
                setCandidates([]);
                setFilteredCandidates([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCandidates();
    }, []);

    // Apply filters whenever filter criteria change
    useEffect(() => {
        let result = [...candidates];

        // Filter by job position (using category)
        if (Object.values(jobPosition).some(v => v)) {
            result = result.filter(candidate => {
                // Handle job_position as array
                const jobPositions = Array.isArray(candidate.job_position)
                    ? candidate.job_position.map(pos => pos?.toLowerCase() || '')
                    : [candidate.job_position?.toLowerCase() || ''];

                const jobPositionsString = jobPositions.join(' ');

                return (
                    (jobPosition.maid && jobPositionsString.includes('maid')) ||
                    (jobPosition.driver && jobPositionsString.includes('driver')) ||
                    (jobPosition.cook && jobPositionsString.includes('cook')) ||
                    (jobPosition.nanny && jobPositionsString.includes('nanny')) ||
                    (jobPosition.nurse && jobPositionsString.includes('nurse')) ||
                    (jobPosition.houseboy && jobPositionsString.includes('houseboy')) ||
                    (jobPosition.tailor && jobPositionsString.includes('tailor')) ||
                    (jobPosition.teacher && jobPositionsString.includes('teacher')) ||
                    (jobPosition.trainer && jobPositionsString.includes('trainer')) ||
                    (jobPosition.gardener && jobPositionsString.includes('gardener')) ||
                    (jobPosition.butler && jobPositionsString.includes('butler')) ||
                    (jobPosition.housekeeper && jobPositionsString.includes('housekeeper')) ||
                    (jobPosition.laundryWorker && jobPositionsString.includes('laundry')) ||
                    (jobPosition.personalAssistant && jobPositionsString.includes('personal assistant')) ||
                    (jobPosition.caregiver && jobPositionsString.includes('caregiver')) ||
                    (jobPosition.elderCareCompanion && jobPositionsString.includes('elder care')) ||
                    (jobPosition.petSitter && (jobPositionsString.includes('pet') || jobPositionsString.includes('dog walker'))) ||
                    (jobPosition.houseManager && jobPositionsString.includes('house manager')) ||
                    (jobPosition.cleaner && jobPositionsString.includes('cleaner')) ||
                    (jobPosition.maintenanceWorker && (jobPositionsString.includes('maintenance') || jobPositionsString.includes('handyman'))) ||
                    (jobPosition.babySitter && jobPositionsString.includes('baby sitter')) ||
                    (jobPosition.tutor && jobPositionsString.includes('tutor')) ||
                    (jobPosition.chauffeur && jobPositionsString.includes('chauffeur')) ||
                    (jobPosition.housemaid && jobPositionsString.includes('housemaid')) ||
                    (jobPosition.kitchenStaff && jobPositionsString.includes('kitchen staff')) ||
                    (jobPosition.diningRoomAttendant && jobPositionsString.includes('dining room')) ||
                    (jobPosition.personalChef && jobPositionsString.includes('personal chef')) ||
                    (jobPosition.eventCoordinator && jobPositionsString.includes('event coordinator')) ||
                    (jobPosition.householdAdministrator && jobPositionsString.includes('household administrator')) ||
                    (jobPosition.domesticAssistant && jobPositionsString.includes('domestic assistant'))
                );
            });
        }

        // Filter by job country (using country_apply_for_job field)
        if (Object.values(jobCountry).some(v => v)) {
            result = result.filter(candidate => {
                const applyForCountry = candidate.country_apply_for_job?.toLowerCase() || '';
                return (
                    (jobCountry.qatar && applyForCountry.includes('qatar')) ||
                    (jobCountry.uae && (applyForCountry.includes('uae') || applyForCountry.includes('united arab emirates') || applyForCountry.includes('dubai') || applyForCountry.includes('abu dhabi'))) ||
                    (jobCountry.saudiArabia && (applyForCountry.includes('saudi') || applyForCountry.includes('ksa') || applyForCountry.includes('riyadh') || applyForCountry.includes('jeddah'))) ||
                    (jobCountry.kuwait && applyForCountry.includes('kuwait')) ||
                    (jobCountry.bahrain && applyForCountry.includes('bahrain')) ||
                    (jobCountry.oman && applyForCountry.includes('oman')) ||
                    (jobCountry.usa && (applyForCountry.includes('usa') || applyForCountry.includes('united states') || applyForCountry.includes('america'))) ||
                    (jobCountry.canada && applyForCountry.includes('canada')) ||
                    (jobCountry.uk && (applyForCountry.includes('uk') || applyForCountry.includes('united kingdom') || applyForCountry.includes('england') || applyForCountry.includes('britain'))) ||
                    (jobCountry.australia && applyForCountry.includes('australia')) ||
                    (jobCountry.germany && applyForCountry.includes('germany')) ||
                    (jobCountry.france && applyForCountry.includes('france')) ||
                    (jobCountry.italy && applyForCountry.includes('italy')) ||
                    (jobCountry.spain && applyForCountry.includes('spain')) ||
                    (jobCountry.netherlands && applyForCountry.includes('netherlands')) ||
                    (jobCountry.belgium && applyForCountry.includes('belgium')) ||
                    (jobCountry.switzerland && applyForCountry.includes('switzerland')) ||
                    (jobCountry.sweden && applyForCountry.includes('sweden')) ||
                    (jobCountry.norway && applyForCountry.includes('norway')) ||
                    (jobCountry.denmark && applyForCountry.includes('denmark')) ||
                    (jobCountry.finland && applyForCountry.includes('finland')) ||
                    (jobCountry.japan && applyForCountry.includes('japan')) ||
                    (jobCountry.southKorea && (applyForCountry.includes('south korea') || applyForCountry.includes('korea'))) ||
                    (jobCountry.singapore && applyForCountry.includes('singapore')) ||
                    (jobCountry.malaysia && applyForCountry.includes('malaysia')) ||
                    (jobCountry.china && applyForCountry.includes('china')) ||
                    (jobCountry.hongKong && (applyForCountry.includes('hong kong') || applyForCountry.includes('hongkong'))) ||
                    (jobCountry.newZealand && (applyForCountry.includes('new zealand') || applyForCountry.includes('new zealand'))) ||
                    (jobCountry.southAfrica && (applyForCountry.includes('south africa') || applyForCountry.includes('south africa'))) ||
                    (jobCountry.brazil && applyForCountry.includes('brazil')) ||
                    (jobCountry.mexico && applyForCountry.includes('mexico')) ||
                    (jobCountry.argentina && applyForCountry.includes('argentina')) ||
                    (jobCountry.chile && applyForCountry.includes('chile')) ||
                    (jobCountry.colombia && applyForCountry.includes('colombia')) ||
                    (jobCountry.peru && applyForCountry.includes('peru')) ||
                    (jobCountry.egypt && applyForCountry.includes('egypt')) ||
                    (jobCountry.morocco && applyForCountry.includes('morocco')) ||
                    (jobCountry.algeria && applyForCountry.includes('algeria')) ||
                    (jobCountry.tunisia && applyForCountry.includes('tunisia')) ||
                    (jobCountry.jordan && applyForCountry.includes('jordan')) ||
                    (jobCountry.lebanon && applyForCountry.includes('lebanon')) ||
                    (jobCountry.iraq && applyForCountry.includes('iraq')) ||
                    (jobCountry.iran && applyForCountry.includes('iran')) ||
                    (jobCountry.turkey && applyForCountry.includes('turkey')) ||
                    (jobCountry.cyprus && applyForCountry.includes('cyprus')) ||
                    (jobCountry.malta && applyForCountry.includes('malta')) ||
                    (jobCountry.greece && applyForCountry.includes('greece')) ||
                    (jobCountry.portugal && applyForCountry.includes('portugal')) ||
                    (jobCountry.austria && applyForCountry.includes('austria')) ||
                    (jobCountry.hungary && applyForCountry.includes('hungary')) ||
                    (jobCountry.poland && applyForCountry.includes('poland')) ||
                    (jobCountry.czechRepublic && (applyForCountry.includes('czech') || applyForCountry.includes('czech republic'))) ||
                    (jobCountry.slovakia && applyForCountry.includes('slovakia')) ||
                    (jobCountry.slovenia && applyForCountry.includes('slovenia')) ||
                    (jobCountry.croatia && applyForCountry.includes('croatia')) ||
                    (jobCountry.romania && applyForCountry.includes('romania')) ||
                    (jobCountry.bulgaria && applyForCountry.includes('bulgaria')) ||
                    (jobCountry.serbia && applyForCountry.includes('serbia')) ||
                    (jobCountry.montenegro && applyForCountry.includes('montenegro')) ||
                    (jobCountry.albania && applyForCountry.includes('albania')) ||
                    (jobCountry.northMacedonia && (applyForCountry.includes('north macedonia') || applyForCountry.includes('macedonia'))) ||
                    (jobCountry.bosniaHerzegovina && (applyForCountry.includes('bosnia') || applyForCountry.includes('herzegovina'))) ||
                    (jobCountry.kosovo && applyForCountry.includes('kosovo')) ||
                    (jobCountry.estonia && applyForCountry.includes('estonia')) ||
                    (jobCountry.latvia && applyForCountry.includes('latvia')) ||
                    (jobCountry.lithuania && applyForCountry.includes('lithuania')) ||
                    (jobCountry.belarus && applyForCountry.includes('belarus')) ||
                    (jobCountry.ukraine && applyForCountry.includes('ukraine')) ||
                    (jobCountry.moldova && applyForCountry.includes('moldova')) ||
                    (jobCountry.georgia && applyForCountry.includes('georgia')) ||
                    (jobCountry.armenia && applyForCountry.includes('armenia')) ||
                    (jobCountry.azerbaijan && applyForCountry.includes('azerbaijan')) ||
                    (jobCountry.kazakhstan && applyForCountry.includes('kazakhstan')) ||
                    (jobCountry.uzbekistan && applyForCountry.includes('uzbekistan')) ||
                    (jobCountry.turkmenistan && applyForCountry.includes('turkmenistan')) ||
                    (jobCountry.kyrgyzstan && applyForCountry.includes('kyrgyzstan')) ||
                    (jobCountry.tajikistan && applyForCountry.includes('tajikistan')) ||
                    (jobCountry.afghanistan && applyForCountry.includes('afghanistan')) ||
                    (jobCountry.pakistan && applyForCountry.includes('pakistan')) ||
                    (jobCountry.india && applyForCountry.includes('india')) ||
                    (jobCountry.bangladesh && applyForCountry.includes('bangladesh')) ||
                    (jobCountry.sriLanka && (applyForCountry.includes('sri lanka') || applyForCountry.includes('sri lanka'))) ||
                    (jobCountry.nepal && applyForCountry.includes('nepal')) ||
                    (jobCountry.bhutan && applyForCountry.includes('bhutan')) ||
                    (jobCountry.myanmar && applyForCountry.includes('myanmar')) ||
                    (jobCountry.thailand && applyForCountry.includes('thailand')) ||
                    (jobCountry.laos && applyForCountry.includes('laos')) ||
                    (jobCountry.cambodia && applyForCountry.includes('cambodia')) ||
                    (jobCountry.vietnam && applyForCountry.includes('vietnam')) ||
                    (jobCountry.indonesia && applyForCountry.includes('indonesia')) ||
                    (jobCountry.philippines && applyForCountry.includes('philippines')) ||
                    (jobCountry.brunei && applyForCountry.includes('brunei')) ||
                    (jobCountry.eastTimor && (applyForCountry.includes('east timor') || applyForCountry.includes('timor-leste'))) ||
                    (jobCountry.papuaNewGuinea && (applyForCountry.includes('papua new guinea') || applyForCountry.includes('papua new guinea'))) ||
                    (jobCountry.fiji && applyForCountry.includes('fiji')) ||
                    (jobCountry.solomonIslands && (applyForCountry.includes('solomon islands') || applyForCountry.includes('solomon islands'))) ||
                    (jobCountry.vanuatu && applyForCountry.includes('vanuatu')) ||
                    (jobCountry.samoa && applyForCountry.includes('samoa')) ||
                    (jobCountry.tonga && applyForCountry.includes('tonga')) ||
                    (jobCountry.marshallIslands && (applyForCountry.includes('marshall islands') || applyForCountry.includes('marshall islands'))) ||
                    (jobCountry.micronesia && applyForCountry.includes('micronesia')) ||
                    (jobCountry.palau && applyForCountry.includes('palau')) ||
                    (jobCountry.nauru && applyForCountry.includes('nauru')) ||
                    (jobCountry.tuvalu && applyForCountry.includes('tuvalu')) ||
                    (jobCountry.kiribati && applyForCountry.includes('kiribati'))
                );
            });
        }

        // Filter by candidate nationality
        const selectedLocations = [];
        if (candidateLocation.india) selectedLocations.push('india');
        if (candidateLocation.bangladesh) selectedLocations.push('bangladesh');
        if (candidateLocation.nepal) selectedLocations.push('nepal');
        if (candidateLocation.sriLanka) selectedLocations.push('sri lanka', 'sri lankan');
        if (candidateLocation.pakistan) selectedLocations.push('pakistan');
        if (candidateLocation.philippines) selectedLocations.push('philippines');
        if (candidateLocation.indonesia) selectedLocations.push('indonesia');
        if (candidateLocation.myanmar) selectedLocations.push('myanmar', 'burma');
        if (candidateLocation.vietnam) selectedLocations.push('vietnam');
        if (candidateLocation.cambodia) selectedLocations.push('cambodia');
        if (candidateLocation.thailand) selectedLocations.push('thailand');
        if (candidateLocation.ethiopia) selectedLocations.push('ethiopia');
        if (candidateLocation.kenya) selectedLocations.push('kenya');
        if (candidateLocation.uganda) selectedLocations.push('uganda');
        if (candidateLocation.tanzania) selectedLocations.push('tanzania');
        if (candidateLocation.rwanda) selectedLocations.push('rwanda');
        if (candidateLocation.ghana) selectedLocations.push('ghana');
        if (candidateLocation.nigeria) selectedLocations.push('nigeria');
        if (candidateLocation.sierraLeone) selectedLocations.push('sierra leone');
        if (candidateLocation.burundi) selectedLocations.push('burundi');

        if (selectedLocations.length > 0) {
            result = result.filter(candidate => {
                const nationality = candidate.nationality?.toLowerCase() || '';
                return selectedLocations.some(location => nationality.includes(location));
            });
        }

        // Filter by job type (using current_work_status)
        if (
            jobType.fullTime || jobType.partTime || jobType.liveIn || jobType.liveOut ||
            jobType.temporary || jobType.permanent || jobType.internship || jobType.contractual ||
            jobType.freelance || jobType.volunteer || jobType.fresher
        ) {
            result = result.filter(candidate => {
                const type = candidate.job_type?.toLowerCase() || '';
                return (
                    (jobType.fullTime && type.includes('full time')) ||
                    (jobType.partTime && type.includes('part time')) ||
                    (jobType.liveIn && type.includes('live in')) ||
                    (jobType.liveOut && type.includes('live out')) ||
                    (jobType.temporary && type.includes('temporary')) ||
                    (jobType.permanent && type.includes('permanent')) ||
                    (jobType.internship && type.includes('internship')) ||
                    (jobType.contractual && type.includes('contractual')) ||
                    (jobType.freelance && type.includes('freelance')) ||
                    (jobType.volunteer && type.includes('volunteer')) ||
                    (jobType.fresher && type.includes('fresher'))
                );
            });
        }

        // Filter by contract status (using visa_type)
        if (contractStatus.permanent || contractStatus.temporary || contractStatus.contract) {
            result = result.filter(candidate => {
                const status = candidate.visa_type?.toLowerCase();
                return (contractStatus.permanent && status?.includes('permanent')) ||
                    (contractStatus.temporary && status?.includes('temporary')) ||
                    (contractStatus.contract && status?.includes('contract'));
            });
        }

        // Filter by posted by (using source - assuming this field exists)
        if (postedBy.agency || postedBy.directEmployer) {
            result = result.filter(candidate => {
                const source = candidate.source?.toLowerCase();
                return (postedBy.agency && source?.includes('agency')) ||
                    (postedBy.directEmployer && source?.includes('direct'));
            });
        }

        // Filter by language (using language array)
        if (
            language.english || language.mandarin || language.arabic || language.hindi ||
            language.tagalog || language.cantonese || language.malay || language.tamil
        ) {
            result = result.filter(candidate => {
                const langs = candidate.language?.map(l => l.language?.toLowerCase()).join(' ') || '';
                return (
                    (language.english && langs.includes('english')) ||
                    (language.mandarin && langs.includes('mandarin')) ||
                    (language.arabic && langs.includes('arabic')) ||
                    (language.hindi && langs.includes('hindi')) ||
                    (language.tagalog && langs.includes('tagalog')) ||
                    (language.cantonese && langs.includes('cantonese')) ||
                    (language.malay && langs.includes('malay')) ||
                    (language.tamil && langs.includes('tamil'))
                );
            });
        }

        // Filter by main skills (using main_skills array)
        if (
            mainSkills.childcare || mainSkills.elderlyCare || mainSkills.cooking ||
            mainSkills.cleaning || mainSkills.laundry || mainSkills.ironing ||
            mainSkills.petCare || mainSkills.gardening
        ) {
            result = result.filter(candidate => {
                const skills = candidate.main_skills?.join(' ').toLowerCase() || '';
                return (
                    (mainSkills.childcare && skills.includes('childcare')) ||
                    (mainSkills.elderlyCare && skills.includes('elderly care')) ||
                    (mainSkills.cooking && skills.includes('cooking')) ||
                    (mainSkills.cleaning && skills.includes('cleaning')) ||
                    (mainSkills.laundry && skills.includes('laundry')) ||
                    (mainSkills.ironing && skills.includes('ironing')) ||
                    (mainSkills.petCare && skills.includes('pet care')) ||
                    (mainSkills.gardening && skills.includes('gardening'))
                );
            });
        }

        // Filter by start date (using preferred_start_date)
        if (startDate) {
            try {
                const selectedDate = new Date(startDate);
                selectedDate.setHours(0, 0, 0, 0);

                result = result.filter(candidate => {
                    if (!candidate.preferred_start_date) return false;

                    try {
                        const candidateDate = new Date(candidate.preferred_start_date);
                        candidateDate.setHours(0, 0, 0, 0);
                        return candidateDate >= selectedDate;
                    } catch (e) {
                        console.error('Error parsing candidate date:', candidate.preferred_start_date, e);
                        return false;
                    }
                });
            } catch (e) {
                console.error('Error parsing selected date:', startDate, e);
            }
        }

        // Search filter (name, nationality, job position)
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(candidate => {
                const name = `${candidate.first_name || ''} ${candidate.last_name || ''} ${candidate.full_name || candidate.name || ''}`.toLowerCase();
                const nationality = (candidate.nationality || '').toLowerCase();
                const jobPosition = Array.isArray(candidate.job_position)
                    ? candidate.job_position.join(' ')
                    : (candidate.job_position || '');
                const jobPositionLower = String(jobPosition).toLowerCase();
                return (
                    name.includes(term) ||
                    nationality.includes(term) ||
                    jobPositionLower.includes(term)
                );
            });
        }

        setFilteredCandidates(result);
    }, [
        candidates,
        jobPosition,
        candidateLocation,
        jobCountry,
        jobType,
        contractStatus,
        postedBy,
        language,
        mainSkills,
        startDate,
        searchTerm
    ]);

    if (loading) {
        return (
            <>
                <AdminNavbar />
                <div className="text-center mt-5">Loading candidates...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <AdminNavbar />
                <div className="text-center mt-5 text-danger">Error: {error}</div>
            </>
        );
    }

    return (
        <>
            <AdminNavbar />
            <Container fluid className="p-3">
                {/* Message Modal */}
                <Modal show={showMessageModal} onHide={handleCloseMessageModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Message {selectedCandidate?.first_name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Message History */}
                        <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '20px', border: '1px solid #eee', padding: '10px', borderRadius: '0px' }}>
                            {messages.length > 0 ? (
                                messages.map((msg, index) => (
                                    <div key={index} style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: index < messages.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                            You - {new Date(msg.created_at).toLocaleString()}
                                        </div>
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{msg.message}</div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: 'center', color: '#777' }}>No previous messages</div>
                            )}
                        </div>

                        {/* New Message Form */}
                        <Form.Group controlId="messageContent">
                            <Form.Label>Your Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={messageContent}
                                onChange={handleMessageContentChange}
                                placeholder={`Write your message to ${selectedCandidate?.first_name}...`}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseMessageModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSendMessage}>
                            Send Message
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Share Modal */}
                <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Share Candidate Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p className="mb-4">Share this candidate profile via:</p>

                        <div className="d-flex justify-content-center gap-3 mb-4">
                            {/* WhatsApp */}
                            <Button
                                variant="success"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaWhatsApp(shareContent)}
                            >
                                <i className="bi bi-whatsapp fs-4"></i>
                            </Button>

                            {/* Facebook */}
                            <Button
                                variant="primary"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaFacebook(shareUrl)}
                            >
                                <i className="bi bi-facebook fs-4"></i>
                            </Button>

                            {/* Twitter */}
                            <Button
                                variant="info"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaTwitter(shareContent)}
                            >
                                <i className="bi bi-twitter fs-4"></i>
                            </Button>

                            {/* LinkedIn */}
                            <Button
                                variant="primary"
                                className="rounded-circle share-btn"
                                style={{ backgroundColor: '#0077b5' }}
                                onClick={() => shareViaLinkedIn(shareUrl)}
                            >
                                <i className="bi bi-linkedin fs-4"></i>
                            </Button>

                            {/* Copy Link */}
                            <Button
                                variant="secondary"
                                className="rounded-circle share-btn"
                                onClick={() => copyToClipboard(shareUrl)}
                            >
                                <i className="bi bi-link-45deg fs-4"></i>
                            </Button>
                        </div>

                        {/* Shareable text */}
                        <Form.Group>
                            <Form.Label>Share this text:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={shareContent}
                                readOnly
                                onClick={(e) => e.target.select()}
                            />
                        </Form.Group>
                    </Modal.Body>
                </Modal>

                {/* Mobile Filter Toggle Button */}
                {isMobile && (
                    <div className="mb-3">
                        <button
                            className="btn btn-primary w-100"
                            onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                        >
                            <i className="bi bi-funnel me-2"></i>
                            {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                        </button>
                    </div>
                )}

                <Row style={{ marginTop: "75px" }}>
                    {/* Filter Section */}
                    {(showFiltersMobile || !isMobile) && (
                        <Col md={2}>
                            <div className="viewjobposting-filters p-3 border rounded bg-light">
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {/* Candidate Nationality Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Candidate Nationality</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'india', name: 'India' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'ethiopia', name: 'Ethiopia' },
                                                { id: 'kenya', name: 'Kenya' },
                                                { id: 'uganda', name: 'Uganda' },
                                                { id: 'tanzania', name: 'Tanzania' },
                                                { id: 'rwanda', name: 'Rwanda' },
                                                { id: 'ghana', name: 'Ghana' },
                                                { id: 'nigeria', name: 'Nigeria' },
                                                { id: 'sierraLeone', name: 'Sierra Leone' },
                                                { id: 'burundi', name: 'Burundi' }
                                            ].slice(0, showMoreLocations ? 16 : 5).map((location) => (
                                                <div key={location.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`location-${location.id}`}
                                                        checked={candidateLocation[location.id]}
                                                        onChange={(e) => handleCandidateLocationChange({
                                                            target: {
                                                                name: location.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`location-${location.id}`}>
                                                        {location.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(candidateLocation).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={toggleMoreLocations}
                                                >
                                                    {showMoreLocations ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Candidate Job Country Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                    >
                                        <strong>Candidate Job Country</strong>
                                        <i className={`bi ${showMoreJobCountry ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobCountry && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                // Gulf Countries
                                                { id: 'qatar', name: 'Qatar' },
                                                { id: 'uae', name: 'UAE/Dubai' },
                                                { id: 'saudiArabia', name: 'Saudi Arabia' },
                                                { id: 'kuwait', name: 'Kuwait' },
                                                { id: 'bahrain', name: 'Bahrain' },
                                                { id: 'oman', name: 'Oman' },

                                                // North America
                                                { id: 'usa', name: 'USA' },
                                                { id: 'canada', name: 'Canada' },

                                                // Europe
                                                { id: 'uk', name: 'United Kingdom' },
                                                { id: 'germany', name: 'Germany' },
                                                { id: 'france', name: 'France' },
                                                { id: 'italy', name: 'Italy' },
                                                { id: 'spain', name: 'Spain' },
                                                { id: 'netherlands', name: 'Netherlands' },
                                                { id: 'belgium', name: 'Belgium' },
                                                { id: 'switzerland', name: 'Switzerland' },
                                                { id: 'sweden', name: 'Sweden' },
                                                { id: 'norway', name: 'Norway' },
                                                { id: 'denmark', name: 'Denmark' },
                                                { id: 'finland', name: 'Finland' },
                                                { id: 'austria', name: 'Austria' },
                                                { id: 'hungary', name: 'Hungary' },
                                                { id: 'poland', name: 'Poland' },
                                                { id: 'czechRepublic', name: 'Czech Republic' },
                                                { id: 'slovakia', name: 'Slovakia' },
                                                { id: 'slovenia', name: 'Slovenia' },
                                                { id: 'croatia', name: 'Croatia' },
                                                { id: 'romania', name: 'Romania' },
                                                { id: 'bulgaria', name: 'Bulgaria' },
                                                { id: 'serbia', name: 'Serbia' },
                                                { id: 'montenegro', name: 'Montenegro' },
                                                { id: 'albania', name: 'Albania' },
                                                { id: 'northMacedonia', name: 'North Macedonia' },
                                                { id: 'bosniaHerzegovina', name: 'Bosnia & Herzegovina' },
                                                { id: 'kosovo', name: 'Kosovo' },
                                                { id: 'estonia', name: 'Estonia' },
                                                { id: 'latvia', name: 'Latvia' },
                                                { id: 'lithuania', name: 'Lithuania' },
                                                { id: 'belarus', name: 'Belarus' },
                                                { id: 'ukraine', name: 'Ukraine' },
                                                { id: 'moldova', name: 'Moldova' },
                                                { id: 'georgia', name: 'Georgia' },
                                                { id: 'armenia', name: 'Armenia' },
                                                { id: 'azerbaijan', name: 'Azerbaijan' },

                                                // Asia Pacific
                                                { id: 'japan', name: 'Japan' },
                                                { id: 'southKorea', name: 'South Korea' },
                                                { id: 'singapore', name: 'Singapore' },
                                                { id: 'malaysia', name: 'Malaysia' },
                                                { id: 'china', name: 'China' },
                                                { id: 'hongKong', name: 'Hong Kong' },
                                                { id: 'australia', name: 'Australia' },
                                                { id: 'newZealand', name: 'New Zealand' },

                                                // South Asia
                                                { id: 'india', name: 'India' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'bhutan', name: 'Bhutan' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'laos', name: 'Laos' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'brunei', name: 'Brunei' },
                                                { id: 'eastTimor', name: 'East Timor' },

                                                // Middle East & Africa
                                                { id: 'turkey', name: 'Turkey' },
                                                { id: 'cyprus', name: 'Cyprus' },
                                                { id: 'malta', name: 'Malta' },
                                                { id: 'egypt', name: 'Egypt' },
                                                { id: 'morocco', name: 'Morocco' },
                                                { id: 'algeria', name: 'Algeria' },
                                                { id: 'tunisia', name: 'Tunisia' },
                                                { id: 'jordan', name: 'Jordan' },
                                                { id: 'lebanon', name: 'Lebanon' },
                                                { id: 'iraq', name: 'Iraq' },
                                                { id: 'iran', name: 'Iran' },
                                                { id: 'southAfrica', name: 'South Africa' },

                                                // Central Asia
                                                { id: 'kazakhstan', name: 'Kazakhstan' },
                                                { id: 'uzbekistan', name: 'Uzbekistan' },
                                                { id: 'turkmenistan', name: 'Turkmenistan' },
                                                { id: 'kyrgyzstan', name: 'Kyrgyzstan' },
                                                { id: 'tajikistan', name: 'Tajikistan' },
                                                { id: 'afghanistan', name: 'Afghanistan' },

                                                // Latin America
                                                { id: 'brazil', name: 'Brazil' },
                                                { id: 'mexico', name: 'Mexico' },
                                                { id: 'argentina', name: 'Argentina' },
                                                { id: 'chile', name: 'Chile' },
                                                { id: 'colombia', name: 'Colombia' },
                                                { id: 'peru', name: 'Peru' },

                                                // Pacific Islands
                                                { id: 'papuaNewGuinea', name: 'Papua New Guinea' },
                                                { id: 'fiji', name: 'Fiji' },
                                                { id: 'solomonIslands', name: 'Solomon Islands' },
                                                { id: 'vanuatu', name: 'Vanuatu' },
                                                { id: 'samoa', name: 'Samoa' },
                                                { id: 'tonga', name: 'Tonga' },
                                                { id: 'marshallIslands', name: 'Marshall Islands' },
                                                { id: 'micronesia', name: 'Micronesia' },
                                                { id: 'palau', name: 'Palau' },
                                                { id: 'nauru', name: 'Nauru' },
                                                { id: 'tuvalu', name: 'Tuvalu' },
                                                { id: 'kiribati', name: 'Kiribati' }
                                            ].map((country) => (
                                                <div key={country.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`jobCountry-${country.id}`}
                                                        checked={jobCountry[country.id]}
                                                        onChange={(e) => handleJobCountryChange({
                                                            target: {
                                                                name: country.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobCountry-${country.id}`}>
                                                        {country.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <button
                                                className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                style={{ textAlign: 'left' }}
                                                onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                            >
                                                {showMoreJobCountry ? 'Show Less' : 'Show More'}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showMoreJobPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobPosition && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'maid', name: 'Maid' },
                                                { id: 'driver', name: 'Driver' },
                                                { id: 'cook', name: 'Cook' },
                                                { id: 'nanny', name: 'Nanny' },
                                                { id: 'nurse', name: 'Nurse' },
                                                { id: 'houseboy', name: 'Houseboy' },
                                                { id: 'tailor', name: 'Tailor' },
                                                { id: 'teacher', name: 'Teacher' },
                                                { id: 'trainer', name: 'Trainer' },
                                                { id: 'gardener', name: 'Gardener' },
                                                { id: 'butler', name: 'Butler' },
                                                { id: 'housekeeper', name: 'Housekeeper' },
                                                { id: 'laundryWorker', name: 'Laundry Worker' },
                                                { id: 'personalAssistant', name: 'Personal Assistant' },
                                                { id: 'caregiver', name: 'Caregiver' },
                                                { id: 'elderCareCompanion', name: 'Elder Care Companion' },
                                                { id: 'petSitter', name: 'Pet Sitter' },
                                                { id: 'houseManager', name: 'House Manager' },
                                                { id: 'cleaner', name: 'Cleaner' },
                                                { id: 'maintenanceWorker', name: 'Maintenance Worker' },
                                                { id: 'babySitter', name: 'Baby Sitter' },
                                                { id: 'tutor', name: 'Tutor' },
                                                { id: 'chauffeur', name: 'Chauffeur' },
                                                { id: 'housemaid', name: 'Housemaid' },
                                                { id: 'kitchenStaff', name: 'Kitchen Staff' },
                                                { id: 'diningRoomAttendant', name: 'Dining Room Attendant' },
                                                { id: 'personalChef', name: 'Personal Chef' },
                                                { id: 'eventCoordinator', name: 'Event Coordinator' },
                                                { id: 'householdAdministrator', name: 'Household Administrator' },
                                                { id: 'domesticAssistant', name: 'Domestic Assistant' }
                                            ].slice(0, showMoreJobPosition ? 30 : 5).map((position) => (
                                                <div key={position.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`position-${position.id}`}
                                                        checked={jobPosition[position.id]}
                                                        onChange={(e) => handleJobPositionChange({
                                                            target: {
                                                                name: position.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`position-${position.id}`}>
                                                        {position.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobPosition).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                                >
                                                    {showMoreJobPosition ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobType(!showMoreJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showMoreJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobType && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'fullTime', name: 'Full Time' },
                                                { id: 'partTime', name: 'Part Time' },
                                                { id: 'liveIn', name: 'Live In' },
                                                { id: 'liveOut', name: 'Live Out' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'internship', name: 'Internship' },
                                                { id: 'contractual', name: 'Contractual' },
                                                { id: 'freelance', name: 'Freelance' },
                                                { id: 'volunteer', name: 'Volunteer' },
                                                { id: 'fresher', name: 'Fresher' }
                                            ].slice(0, showMoreJobType ? 11 : 5).map((type) => (
                                                <div key={type.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`jobType-${type.id}`}
                                                        checked={jobType[type.id]}
                                                        onChange={(e) => handleJobTypeChange({
                                                            target: {
                                                                name: type.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobType-${type.id}`}>
                                                        {type.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobType).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobType(!showMoreJobType)}
                                                >
                                                    {showMoreJobType ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'contract', name: 'Contract' }
                                            ].map((status) => (
                                                <div key={status.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`contract-${status.id}`}
                                                        checked={contractStatus[status.id]}
                                                        onChange={(e) => handleContractStatusChange({
                                                            target: {
                                                                name: status.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`contract-${status.id}`}>
                                                        {status.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Posted By Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowPostedBy(!showPostedBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostedBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostedBy && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'agency', name: 'Agency' },
                                                { id: 'directEmployer', name: 'Direct Employer' }
                                            ].map((post) => (
                                                <div key={post.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`postedBy-${post.id}`}
                                                        checked={postedBy[post.id]}
                                                        onChange={(e) => handlePostedByChange({
                                                            target: {
                                                                name: post.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`postedBy-${post.id}`}>
                                                        {post.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showMoreLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreLanguage && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'english', name: 'English' },
                                                { id: 'mandarin', name: 'Mandarin' },
                                                { id: 'arabic', name: 'Arabic' },
                                                { id: 'hindi', name: 'Hindi' },
                                                { id: 'tagalog', name: 'Tagalog' },
                                                { id: 'cantonese', name: 'Cantonese' },
                                                { id: 'malay', name: 'Malay' },
                                                { id: 'tamil', name: 'Tamil' }
                                            ].slice(0, showMoreLanguage ? 8 : 5).map((lang) => (
                                                <div key={lang.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`language-${lang.id}`}
                                                        checked={language[lang.id]}
                                                        onChange={(e) => handleLanguageChange({
                                                            target: {
                                                                name: lang.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`language-${lang.id}`}>
                                                        {lang.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(language).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                                >
                                                    {showMoreLanguage ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreMainSkills(!showMoreMainSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showMoreMainSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreMainSkills && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'childcare', name: 'Childcare' },
                                                { id: 'elderlyCare', name: 'Elderly Care' },
                                                { id: 'cooking', name: 'Cooking' },
                                                { id: 'cleaning', name: 'Cleaning' },
                                                { id: 'laundry', name: 'Laundry' },
                                                { id: 'ironing', name: 'Ironing' },
                                                { id: 'petCare', name: 'Pet Care' },
                                                { id: 'gardening', name: 'Gardening' }
                                            ].map((skill) => (
                                                <div key={skill.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`skill-${skill.id}`}
                                                        checked={mainSkills[skill.id]}
                                                        onChange={(e) => handleMainSkillsChange({
                                                            target: {
                                                                name: skill.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                        {skill.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 adminviewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="p-2 bg-white rounded border">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    )}

                    {/* Candidates List */}
                    <Col md={isMobile ? 12 : 10}>
                        <Form
                            className="mb-3"
                            onSubmit={async (e) => {
                                e.preventDefault();
                                await applySearchTerm(searchInput);
                            }}
                        >
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Search by name, nationality, or job position"
                                    className="admin-candidate-search-input"
                                    value={searchInput}
                                    onChange={(e) => {
                                        setSearchInput(e.target.value);
                                    }}
                                />
                                <Button type="submit" variant="primary" className="admin-candidate-search-btn">
                                    Search
                                </Button>
                            </div>
                        </Form>
                        {filteredCandidates.length === 0 ? (
                            <div className="text-center no-jobs-message">No candidates match your filters</div>
                        ) : (
                            <Row>
                                {filteredCandidates.map((candidate) => (
                                    <Col lg={4} md={6} sm={12} xs={12} className="mb-4" key={candidate.id}>
                                        <CandidateCard
                                            candidate={candidate}
                                            onViewClick={() => handleViewClick(candidate.user_id)}
                                            onMessageClick={() => handleMessageClick(candidate)}
                                            onReportClick={() => handleReportClick(candidate)}
                                            onShareClick={handleShareClick}
                                            onShortlistClick={() => handleShortlistClick(candidate)}
                                            isShortlisted={!!shortlistedCandidates[candidate.user_id]}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </Col>
                </Row>
            </Container>

            <ReportCandidate
                candidate={selectedCandidateForReport}
                show={showReportModal}
                onHide={() => setShowReportModal(false)}
            />
        </>
    );
}

function CandidateCard({ candidate, onViewClick, onMessageClick, onReportClick, onShareClick, onShortlistClick, isShortlisted, handleVerify }) {
    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0'); // Ensure 2 digits
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Helper function to get languages - with default value
    const getLanguages = () => {
        if (!candidate.language || candidate.language.length === 0) {
            return 'English, Arabic'; // Default value
        }

        // Get language names from the array of objects
        const languages = candidate.language.map(lang => lang.language);

        // If there are 2 or more languages, show the first two
        if (languages.length >= 2) {
            return `${languages[0]}, ${languages[1]}`;
        }

        // If only 1 language exists, just show it
        return languages[0];
    };

    // Helper function to get main language (for backward compatibility)
    const getMainLanguage = () => {
        if (!candidate.language || candidate.language.length === 0) return 'English, Arabic';
        return `${candidate.language[0].language}`;
    };

    // Helper function to get accommodation preference - with default value
    const getAccommodationPreference = () => {
        if (!candidate.accommodation_preference || candidate.accommodation_preference === 'Not specified') {
            return 'Live in/Live Out'; // Default value
        }
        return candidate.accommodation_preference;
    };

    // Helper function to get visa status - with default value
    const getVisaStatus = () => {
        if (!candidate.visa_type || candidate.visa_type === 'Not specified') {
            return 'Looking for visa'; // Default value
        }
        return candidate.visa_type;
    };

    // Helper function to get available from date - with default value
    const getAvailableFrom = () => {
        const startDate = candidate.preferred_start_date;
        if (!startDate) return 'Immediate'; // Default value

        // Check if it's "Immediate" or similar text
        if (typeof startDate === 'string' && startDate.toLowerCase().includes('immediate')) {
            return 'Immediate';
        }

        try {
            // Try to parse as date
            const date = new Date(startDate);
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            }
            // If not a valid date, return the original string
            return startDate;
        } catch (e) {
            // If parsing fails, return the original value
            return startDate || 'Immediate';
        }
    };

    // Helper function to get main skills
    const getMainSkills = () => {
        if (!candidate.main_skills || candidate.main_skills.length === 0) return 'Not specified';
        const firstSkill = candidate.main_skills[0];
        if (firstSkill.includes('["')) {
            try {
                const parsed = JSON.parse(firstSkill.replace(/\\/g, ''));
                if (Array.isArray(parsed)) {
                    return parsed.join(', ');
                }
                return parsed;
            } catch (e) {
                return firstSkill;
            }
        }
        return firstSkill;
    };

    const getCountryCode = () => {
        // Priority 1: Explicitly stored country code
        let code = candidate.whatsapp_country_code || candidate.mobile_country_code || '';
        if (code) return code.replace(/\D/g, '');

        // Priority 2: Inferred from nationality
        const nationalityToCode = {
            'Philippines': '63',
            'Indonesia': '62',
            'Sri Lanka': '94',
            'India': '91',
            'Nepal': '977',
            'Ethiopia': '251',
            'Kenya': '254',
            'Uganda': '256',
            'Bangladesh': '880',
            'Myanmar': '95',
            'Bahrain': '973',
            'Cyprus': '357',
            'Egypt': '20',
            'Iran': '98',
            'Iraq': '964',
            'Israel': '972',
            'Jordan': '962',
            'Kuwait': '965',
            'Lebanon': '961',
            'Oman': '968',
            'Palestine': '970',
            'Qatar': '974',
            'Saudi Arabia': '966',
            'Syria': '963',
            'Turkey': '90',
            'UAE': '971',
            'Dubai (UAE)': '971',
            'Yemen': '967'
        };

        const nat = candidate.nationality;
        if (nat && nationalityToCode[nat]) {
            return nationalityToCode[nat];
        }

        return '';
    };

    const handleCallClick = () => {
        let phoneNumber = candidate.mobile_number || candidate.whatsapp_number;

        if (!phoneNumber) {
            Swal.fire({
                icon: 'warning',
                title: 'No Number Found',
                text: 'This candidate does not have a contact number listed.',
            });
            return;
        }

        const cleanNumber = phoneNumber.replace(/\D/g, '');

        let finalNumber = '';
        if (phoneNumber.startsWith('+')) {
            finalNumber = phoneNumber.replace(/[^\d+]/g, '');
        } else {
            const cleanCode = getCountryCode();
            if (cleanCode) {
                finalNumber = `+${cleanCode}${cleanNumber}`;
            } else if (cleanNumber.length === 10) {
                finalNumber = `+91${cleanNumber}`;
            } else {
                finalNumber = `+${cleanNumber}`;
            }
        }

        window.location.href = `tel:${finalNumber}`;
    };

    const handleWhatsAppClick = () => {
        let whatsappNumber = candidate.whatsapp_number;

        if (!whatsappNumber) {
            Swal.fire({
                icon: 'warning',
                title: 'No WhatsApp Found',
                text: 'This candidate does not have a WhatsApp number listed.',
            });
            return;
        }

        const cleanNumber = whatsappNumber.replace(/\D/g, '');

        let finalNumber = '';
        if (whatsappNumber.startsWith('+')) {
            finalNumber = whatsappNumber.replace(/\D/g, '');
        } else {
            const cleanCode = getCountryCode() || '91';
            finalNumber = `${cleanCode}${cleanNumber}`;
        }

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : (candidate.job_position || 'candidate');

        const message = `Hi, I'm interested in your ${jobPosition} profile from Gulf Worker website`;

        window.open(`https://wa.me/${finalNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    const isSubscriptionActive = true;
    const isUnlocked = true;

    const handleShortlistClickSafe = () => {
        if (onShortlistClick) onShortlistClick();
    };

    const handleShareClickSafe = () => {
        if (onShareClick) onShareClick();
    };

    const hasPurchasedBadge = Number(candidate.purchased_badge) === 1;
    const hasPurchasedTag = hasVisibleOfferBadge(candidate);
    const hasBothAddOns = hasHighlightedSourceLabel(candidate);

    return (
        <Card className="h-100 shadow-sm rounded card-body-admin-candidate">
            <Card.Body className="d-flex flex-column justify-content-between">
                <div className="d-flex">
                    <div className="me-3 text-center" style={{ marginTop: '15px' }}>
                        <div className="d-flex justify-content-center gap-2 mt-2">
                             {/* ✅ Show Verified if status is verified OR they purchased Verified Tag */}
                            {hasPurchasedBadge && (
                                <div className="verified-status-label-admin mb-2">
                                    <FaCheckCircle className="text-success me-1" />
                                    <span className="fw-bold">Verified</span>
                                </div>
                            )}

                        </div>

                        <div className="profile-img-container-admin">
                            <div className="profile-photo-wrapper-admin">
                                {candidate.profile_photo ? (
                                    <Image
                                        src={candidate.profile_photo}
                                        alt="profile"
                                        className="profile-photo-admin"
                                    />
                                ) : (
                                    <div className="profile-photo-admin d-flex align-items-center justify-content-center bg-light">
                                        <i className="bi bi-person-fill text-muted" style={{ fontSize: '2rem' }}></i>
                                    </div>
                                )}

                                {/* Offer Badge (the green bar on photo bottom) - mapped to purchased_tag */}
                                {hasPurchasedTag && (
                                    <div className="offer-badge-on-photo-admin">
                                        {getVisibleOfferBadgeText(candidate)}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div 
                                className="very-active-label" 
                                style={{ 
                                    color: hasBothAddOns ? '#28a745' : '#6c757d', 
                                    fontWeight: hasBothAddOns ? 'bold' : 'normal',
                                    marginTop: '8px'
                                }}
                            >
                                {getVisibleSourceLabel(candidate)}
                            </div>
                    </div>

                    <div className="flex-grow-1 allcandidate-card-right-admin">
                        {Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("nurse")) ? (
                            // ✅ Custom layout if job_position is Nurse
                            <>
                                <h6 className="fw-bold">
                                    <span style={{ fontWeight: 650 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 list-unstyled candidate-nurse-details-admin">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("doctor")) ? (
                            // ✅ Custom layout if job_position is Doctor
                            <>
                                <h6 className="fw-bold">
                                    <span style={{ fontWeight: 500 }}>
                                        Dr.{candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}years- </span><span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 list-unstyled candidate-doctor-details-admin">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;
                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("driver")) ? (
                            // ✅ Custom layout if job_position is Driver
                            <>
                                <h6 className="fw-bold">
                                    <span style={{ fontWeight: 650 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 list-unstyled candidate-driver-details-admin">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>

                                    <li>
                                        <strong>License - </strong>{' '}
                                        <span>
                                            {candidate.driving_license_country
                                                ? (() => {
                                                    try {
                                                        // Parse if it's a JSON string
                                                        let licenseData = candidate.driving_license_country;

                                                        // Check if it's a string that needs parsing
                                                        if (typeof licenseData === 'string' &&
                                                            (licenseData.startsWith('[') || licenseData.startsWith('"'))) {
                                                            licenseData = JSON.parse(licenseData);
                                                        }

                                                        // Handle array of licenses
                                                        if (Array.isArray(licenseData)) {
                                                            // Process each license to extract only country name
                                                            const processedLicenses = licenseData.map(license => {
                                                                if (typeof license === 'string') {
                                                                    // Extract country name before dash, or use the whole string if no dash
                                                                    const parts = license.split('–').map(part => part.trim());
                                                                    return parts[0]; // Return only the country name
                                                                }
                                                                return license;
                                                            });
                                                            return processedLicenses.join(', ');
                                                        }

                                                        // Handle single license (string)
                                                        if (typeof licenseData === 'string') {
                                                            // Extract country name before dash
                                                            const parts = licenseData.split('–').map(part => part.trim());
                                                            return parts[0]; // Return only the country name
                                                        }

                                                        return licenseData || 'Not specified';
                                                    } catch (e) {
                                                        // If parsing fails, treat as regular string and extract country
                                                        const licenseStr = String(candidate.driving_license_country);
                                                        const parts = licenseStr.split('–').map(part => part.trim());
                                                        return parts[0]; // Return only the country name
                                                    }
                                                })()
                                                : 'Not specified'
                                            }
                                        </span>
                                    </li>

                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : (
                            // ✅ Existing layout for all other job_positions
                            <>
                                <h6 className="fw-bold">
                                    <span style={{ fontWeight: 650 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 list-unstyled candidate-nrml-details-admin">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(", ").trim() || "Not specified"
                                            : candidate.job_position || "Not specified"}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            // Check if both USD and local amounts are 0 or not provided
                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            // Extract currency code from expected_monthly_salary_currency
                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                // Get the first part before space or bracket (e.g., "INR" from "INR (India")
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                // Fallback: Map nationality to currency code
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>

                                    <li>
                                        <strong>Experience -</strong>{" "}
                                        {candidate.total_work_experience || "Not specified"}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>

                                    <li>
                                        <strong>Current Location -</strong>{" "}
                                        <span>{candidate.current_country || "Not specified"}</span>
                                    </li>

                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>

                                    <li>
                                        <strong>Visa Status -</strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>

                                    <li>
                                        <strong>Available From -</strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        )}
                    </div>
                </div>

                                {/* Buttons */}
                <Row className="mt-1">
                    <Col xs={3} className="px-1">
                        <Button
                            variant="light"
                            className="w-100 small-btn action-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                const user = JSON.parse(localStorage.getItem("user")) || {};
                                if (!user || (user.role !== 'agency' && user.role !== 'agency_admin')) {
                                    Swal.fire('Access Denied', 'Video Call feature is only available to Agencies.', 'error');
                                } else if (user.plan_name === 'Free') {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Upgrade Required',
                                        text: 'Video Call feature is available for exclusive plans. Please upgrade.',
                                        confirmButtonText: 'Upgrade Now'
                                    }).then((result) => {
                                        if (result.isConfirmed) window.location.href = '/subscription';
                                    });
                                } else {
                                    window.dispatchEvent(new CustomEvent('initiate-video-call', { 
                                        detail: { 
                                            candidateId: candidate?.user_id || candidate?.id, 
                                            candidateName: candidate?.first_name 
                                        } 
                                    }));
                                }
                            }}
                        >
                            <FaVideo className="text-primary" />
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="secondary" style={{ backgroundColor: '#7177a6' }}
                            className={`w-100 small-btn action-button gap-2 ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleCallClick}
                        >
                            <FaPhoneAlt /> Call
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button variant="allcandidates-veiwbutton" className="w-100 small-btn action-button gap-2 allcandidates-veiwbutton" onClick={onViewClick}>
                            <FaEye /> View
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="success"
                            className={`w-100 small-btn action-button ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleWhatsAppClick}
                        >
                            <i className="bi bi-whatsapp" />
                        </Button>
                    </Col>
                </Row>

                                <Row className="mt-1 text-center text-muted small fw-medium border-top pt-2 last-buttons-row">
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShortlistClickSafe}
                    >
                        {isShortlisted ? (
                            <FaHeart className="text-danger me-1" />
                        ) : (
                            <FaRegHeart className="me-1" />
                        )}
                        Like
                    </Col>
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShareClickSafe}
                    >
                        <i className="bi bi-share me-1"></i> Share
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={onMessageClick}>
                        <i className="bi bi-chat-dots me-1"></i> Message
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={onReportClick}>
                        <i className="bi bi-flag me-1"></i> Report
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default Candidates_admin;
export { CandidateCard as AdminCandidateCard };

